export default class SeasonSelect {
  constructor(config) {
    this.container = config.container
  }

  init() {
    this._initListeners();
    return this;
  }

  _initListeners() {
    const $seasonInput = $($(this.container).find('.season_select')[0]);
    const studentId = $(this.container).data('student-id');
    const $poseInput = $($(this.container).find('.pose_select')[0]);

    $seasonInput.change(() => {
      $.get(`/admin/student_images/poses_for_season.json?season=${$seasonInput.val()}&student_id=${studentId}`, (data) => {
        $poseInput.empty();
        let list = '';

        data.poses.forEach((pose) => {
          list += `<option value="${pose.id}">${pose.url}</option>`
        })

        $poseInput.html(list);
      });
    })
  }
}
